import { Box, styled } from '@mui/material';
import { ReactNode } from 'react';

import { aspectRatio } from 'utils/styles.utils';

import { LOYALTY_BEZIER } from 'constants/loyalty.constants';

interface Props {
  backgroundColor: string;
  borderColor: string;
  mixBlendMode: string;
  children: ReactNode;
}

const PortraitCardContainer = ({
  backgroundColor,
  borderColor,
  mixBlendMode,
  children,
}: Props) => {
  return (
    <PortraitCardWrapper sx={{ backgroundColor }}>
      {children}
      <PortraitCardBorder sx={{ borderColor, mixBlendMode }} />
    </PortraitCardWrapper>
  );
};

const PortraitCardWrapper = styled(Box)(() => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 24,
  ...aspectRatio(9, 16),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  transition: `background-color 0.7s ${LOYALTY_BEZIER}`,
}));

const PortraitCardBorder = styled(Box)({
  position: 'absolute',
  top: 8,
  left: 8,
  width: 'calc(100% - 16px)',
  height: 'calc(100% - 16px)',
  border: '2px solid',
  borderRadius: 20,
  transition: `border-color 0.7s ${LOYALTY_BEZIER}`,
});

export default PortraitCardContainer;
